// @ts-nocheck
import * as React from "react";

const Barrel: React.FC = () => {
    return (
        <svg
            focusable="false"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 80.37 122.88"
            fill="currentColor"
            stroke="0"
        >
            <path
                d="M20.77 12.72c4.42 0 8 1.61 8 3.6s-3.58 3.6-8 3.6-8-1.61-8-3.6 3.58-3.6 8-3.6zM40.1 0
                c10.66 0 20.36 1.64 27.42 4.29 7.66 2.87 12.39 7.04 12.39 11.81 0 1.71-.61 3.34-1.74 4.86v24.66
                c-.9.95-1.97 1.83-3.2 2.64-8.29 5.47-23.18 7.6-37.53 7.16C23.13 54.98 9.47 52 3.6 47.24
                c-.54-.44-1.01-.88-1.39-1.34l.12-.13V21.36C1 19.73.28 17.96.28 16.1c0-4.78 4.74-8.94 12.39-11.81C19.74 1.64 29.44 0 40.1 0
                zm39.59 48.17c.45.94.68 1.91.68 2.91 0 1.8-.77 3.54-2.19 5.15v20.51c-.9.95-1.97 1.83-3.2 2.64-8.29 5.47-23.18 7.6-3
                7.53 7.16-14.32-.44-27.98-3.42-33.85-8.18-.57-.46-1.05-.93-1.44-1.4l.17-.2V56.37C.82 54.71 0 52.93 0 51.07
                c0-.92.2-1.82.59-2.7.37.38.77.74 1.2 1.09 6.36 5.15 20.69 8.36 35.58 8.82 14.86.46 30.38-1.82 39.19-7.63 1.1
                6-.76 2.2-1.59 3.13-2.48zm.04 31.07c.42.91.64 1.86.64 2.82 0 1.8-.77 3.54-2.19 5.15V103c1.19 1.45 1.83 2.99 1.8
                3 4.59 0 8.44-17.83 15.29-39.82 15.29-21.99 0-39.82-6.84-39.82-15.29 0-1.66.69-3.25 1.96-4.74V87.36
                C.82 85.7 0 83.92 0 82.06c0-.89.19-1.76.55-2.61.38.39.79.77 1.24 1.13 6.36 5.15 20.69 8.36 35.58 8.82 14.8
                6.46 30.38-1.82 39.19-7.63 1.17-.78 2.24-1.62 3.17-2.53zM65.76 8.01C59.24 5.56 50.17 4.05 40.1 4.05S20.96 5.5
                6 14.44 8.01c-5.93 2.22-9.6 5.1-9.6 8.09 0 3 3.67 5.87 9.6 8.09 6.52 2.44 15.59 3.96 25.66 3.96s19.14-1.51 25.66-3.96
                c5.93-2.22 9.6-5.1 9.6-8.09s-3.67-5.87-9.6-8.09zm-44.99 6.61c2.69 0 4.87.76 4.87 1.7s-2.18 1.7-4.87 1.7-4.87-.76-4.87-1.7
                c0-.93 2.18-1.7 4.87-1.7z"
                fill-rule="evenodd"
                clip-rule="evenodd"
            />
        </svg>
    );
};

export default React.memo(Barrel);
